import {Trans} from "../utils/i18n";
import Cookies from "js-cookie";
import React from "react";
import {validateVinRegEx, validatePhoneNumber} from "../Shared/FormField";
import {hasProducts} from "./orderEntryEnfore";
import {addressConfig} from "./components/address";

const showContactInformation = (values, orderEntryState) => {
    const {product, requesttype, serialnumber, problem_1, problem_2, problem_description} = values;

    const validProblem = problem_1 && problem_description;

    const validAccessories = Object.keys(values).filter(key => key.startsWith('accessory_') && values[key] > 0).length > 0; // At least one accessory is selected

    return values.requesttype === 'new' && allVariantsChosen || requesttype === 'incident' && orderEntryState?.serialNumber?.order && validProblem || requesttype === 'accessory' && orderEntryState?.serialNumber?.order && validAccessories || requesttype === 'return' && orderEntryState?.serialNumber?.order;
};

export const orderEntryConfigUnzer = {
    "sizes": {
        "forth": 3,
        "third": 4,
        "half": 6,
        "full": 12
    },
    "heading": <Trans i18nKey="orderEntry.basicData">Basic data</Trans>,
    "defaultValues": {
        "private_or_company": "private",
    },
    "groups": [
        {
            "fields": [
                {
                    "size": "full",
                    "component": "requesttypeselect"
                }
            ]
        },
        {
            "id": "product_selection",
            "fields": [
                {
                    "size": "full",
                    "component": "productselectdynamic",
                    "amountOptions": [
                        {
                            value: "10",
                            label: "10",
                        },
                        {
                            value: "20",
                            label: "20",
                        },
                        {
                            value: "50",
                            label: "50",
                        },
                        {
                            value: "100",
                            label: "100",
                        },
                        {
                            value: "250",
                            label: "250",
                        },
                        {
                            value: "500",
                            label: "500",
                        }
                    ],
                },
            ],
            "conditionFunction": values => values.requesttype
        },
        {
            "heading": <Trans i18nKey="orderEntry.upload-receipt">Upload Documents</Trans>,
            "description": <Trans i18nKey="orderEntry.upload-receipt.description">Lorem ipsum dolor sit amet, consetetur
                sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed
                diam voluptua.</Trans>,
            "id": "upload_document",
            "fields": [
                {
                    "size": "full",
                    "component": "dropzoneform",
                    "type": "receipt"
                }
            ],
            "conditionFunction": (values, orderEntryState) => !!values.requesttype && hasProducts(values.products)
        },
        {
            "heading": <Trans i18nKey="orderEntry.addressContact">Address & contact information</Trans>,
            "fields": [
                ...addressConfig,
            ],
            "conditionFunction": (values, orderEntryState) => !!values.requesttype && hasProducts(values.products) && !!orderEntryState?.files?.length
        },

        {
            "heading": <Trans i18nKey="orderEntry.customerReference.label">Customer references</Trans>,
            "fields": [
                {
                    "name": "customer_reference",
                    "label": <Trans i18nKey="orderEntry.customerReference.label">Customer reference</Trans>,
                    "size": "full",
                },
            ],
            "conditionFunction": (values, orderEntryState) => {
                const validName = values?.private_or_company === "private" ? (values?.first_name && values?.last_name) : values?.name;
                const validAddress = validName && values.city && values.street && values.zip && values.country_id;

                return !!values.requesttype && hasProducts(values.products) && !!validAddress && !!orderEntryState?.files?.length;
            }
        },
    ],
    "actions": [
        {
            "fields": [
                {
                    "text": <Trans i18nKey="orderEntry.send">Send</Trans>,
                    "size": "half",
                    "component": "button",
                    "action": "next",
                    "color": "secondary",
                    "conditionFunction": (values, orderEntryState) => {
                        const validName = values?.private_or_company === "private" ? (values?.first_name && values?.last_name) : values?.name;
                        const validAddress = validName && values.city && values.street && values.zip && values.country_id;

                        return !!values.requesttype && hasProducts(values.products) && !!validAddress && !!orderEntryState?.files?.length;
                    }
                }
            ]
        }
    ]
}
